import React from "react";
import "./dashboard.css";
import Chart from "./chart/Chart";
import FeaturedInfo from "./featuredInfo/FeaturedInfo";
import OnboardingBanner from "./onboardingBanner/OnboardingBanner";
import WidgetSm from "./widgetSm/WidgetSm";
import WidgetLg from "./widgetLg/WidgetLg";
import LowStockWidget from "./lowStockWidget/LowStockWidget";
import ErrorBoundary from "../../components/ErrorBoundary";
import { useGetAllOrderQuery } from "../../services/orderApi";
import { revenueByDay } from "../../utils/salesAnalytics";
import { AdminPageHeader } from "../../components/ui";

function AdminDashboard() {
  const { data: orders } = useGetAllOrderQuery();
  const chartData = revenueByDay(orders || []);

  return (
    <div className="home">
      <AdminPageHeader title="Dashboard" subtitle="An overview of orders, revenue, and inventory." />
      <ErrorBoundary><OnboardingBanner /></ErrorBoundary>
      <ErrorBoundary><FeaturedInfo /></ErrorBoundary>
      <div className="homeChart">
        <Chart data={chartData} title="Revenue (last 14 days)" grid dataKey="Revenue" />
      </div>
      <div className="homeWidgets">
        <ErrorBoundary><WidgetSm/></ErrorBoundary>
        <ErrorBoundary><WidgetLg/></ErrorBoundary>
        <ErrorBoundary><LowStockWidget/></ErrorBoundary>
      </div>
    </div>
  );
}

export default AdminDashboard;
